import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth, isAdmin, isCallCenter, homeForUser } from '@/lib/auth';

export default function ProtectedRoute({ children, requireAdmin = false, requireCallCenter = false }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
                <div className="text-slate-500">Loading…</div>
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    const home = homeForUser(user);
    if (requireAdmin && !isAdmin(user)) return <Navigate to={home} replace />;
    if (requireCallCenter && !(isCallCenter(user) || isAdmin(user))) return <Navigate to={home} replace />;
    // A Call Centre agent should only ever see the support console.
    if (!requireAdmin && !requireCallCenter && isCallCenter(user)) return <Navigate to="/support" replace />;
    return children;
}
